// language check depending on url
import { useLocation } from '@reach/router'

export type Language = 'en' | 'de' | 'fr'

export type Translations = { en: string; fr?: string; de?: string }

export const useLanguage = (): Language => {
  const location = useLocation()
  if (location.pathname.startsWith('/fr/')) {
    return 'fr'
  }
  if (location.pathname.startsWith('/de/')) {
    return 'de'
  }
  return 'en'
}
